import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/legal/LegalRenderer.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/legal/[slug]/LegalPage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/privacy/PrivacyChoices.tsx");
